import {FinalWidget, EventsSet, mergeObjects} from './finalWidgets.js';
import Scroll from './FinalCarousel/Scroll.effect.class.js';

export default class FinalCarousel extends FinalWidget{

	static #plugins = [];
	static _defaults = null;

	params = null;
	index = 0;
	current = null;

	constructor( root, params ){

		super();

		if( this.constructor._defaults === null )
			this.constructor._initDefaults();

		// Getting effective params
		this.params = mergeObjects(params ?? {}, this.constructor._defaults);

		let effect_proto = Object.getPrototypeOf(this.params.effect);
		if( effect_proto === Object.prototype || effect_proto === null )
			this.params.effect = new Scroll( root, Object.assign( {align: this.params.align}, this.params.effect )  );


		this.root = root;
		this.current = this.root.children[0];

		this.applyEvents('init_complete', 'finalcarousel');

	}

	swapBy( direction ){

		let target = null;
		let target_index = null;

		if( this.root.children[this.index + direction] ){
			target = this.root.children[ this.index + direction ];
			target_index = this.index + direction;
		} else{
			throw `No element at index ${this.index + direction}`;
		}


		if( !this.params.effect.availableFor( target ) )
			return;

		this.applyEvents('swap_start', 'finalcarousel', [ this.current, target ]);

		this.params.effect.run(
			this.current,
			target,
		)
			.then(() => {
				this.applyEvents('swap_end', 'finalcarousel', [ this.current, target ]);
			})
			.catch(() => this.applyEvents('swap_interrupted', 'finalcarousel', [ this.current, target ]));

		this.current = target;
		this.index = target_index;

	}

	static _initDefaults(){

		this._defaults = {
			on: EventsSet.init('init_complete','swap_start', 'swap_start', 'swap_end', 'swap_interrupted'),
			effect: {
				duration: 450,
				timing: [1, 0, 0, 1]
			},

			align: 'start',
			loop: false,

		}
		
	}

}

